import StyledWrapper from "./style";
import { useEffect, useState } from "react";
import LavorisService from "../../../services/LavorisService";
import { TableActions } from "../../../components/others/TableActions";
import { InfoCard } from "../InfoCard/InfoCard";

type DetailTypes = {
  patient: any;
};

export default function DetailsAbsenteeism({ patient }: DetailTypes) {
  const [isReady, setIsReady] = useState(false);
  const LavorisInstance = LavorisService.getInstance();

  const Row = ({
    label,
    value,
    valueClassName = "",
  }: {
    label: string;
    value: React.ReactNode;
    valueClassName?: string;
  }) => (
    <div className="py-2 border-b border-gray-100 last:border-b-0">
      <div className="grid grid-cols-1 sm:grid-cols-[210px_1fr] gap-1 sm:gap-6 items-start">
        <p className="font-bold text-gray-700">{label}</p>
        <div className={`font-semibold text-gray-900 sm:text-right break-words ${valueClassName}`}>
          {value}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (!patient) return;
    setIsReady(true);
  }, [patient]);

  if (!isReady)
    return (
      <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
        {" "}
        Cargando...{" "}
      </h1>
    );
  return (
    <StyledWrapper.FormContainer>
      <InfoCard absentee={patient} />
      <div className="mt-3 text-xs rounded-xl border border-gray-100 bg-white">
        <div className="px-4 sm:px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-bold text-red-500">Detalle</p>
        </div>

        <div className="px-4 sm:px-6 py-2">
          <Row label="Pedido por:" value={patient?.createdBy || "--"} />
          <Row label="Fecha y Hora:" value={patient?.date || "--"} />
          <Row
            label="Domicilio temporal:"
            value={patient?.not_at_home ? patient?.alternative_adrs || "--" : "No"}
          />
          <Row label="Diagnóstico presunto:" value={patient?.presumedDiagnosis || "--"} />
          <Row
            label="Observaciones:"
            value={patient?.observations || "No hay datos"}
            valueClassName="leading-relaxed"
          />

          {patient?.report?.presentsCertificate && (
            <div className="pt-3">
              <div className="flex items-center justify-between gap-3 px-0 py-2">
                <p className="font-bold text-red-500">Certificado previo</p>
                <p className="text-[11px] font-semibold text-gray-500">
                  {patient?.report?.certificateDate || "--"}
                </p>
              </div>

              <div className="rounded-lg border border-gray-100 bg-gray-50 px-3 sm:px-4">
                <Row label="Presenta:" value="Sí" />
                <Row
                  label="Emitido por:"
                  value={patient?.report?.certificateProfessionalName || "--"}
                />
                <Row
                  label="Matrícula del profesional:"
                  value={patient?.report?.certificateProfessionalLicense || "--"}
                />
                <Row
                  label="Días otorgados:"
                  value={patient?.report?.certificateJustifiedDays || "--"}
                />
                <Row
                  label="Archivo adjunto:"
                  value={
                    patient?.certificateId !== "Not Implemented" ? (
                      <div className="flex flex-col sm:items-end gap-3">
                        <div className="flex justify-start sm:justify-end">
                          <TableActions
                            type="Download"
                            onClick={async () => {
                              await LavorisInstance.FilesService.getCertificateAWSFileById(
                                patient?.certificateId,
                              );
                            }}
                          />
                        </div>
                        {patient?.certificateUrl && (
                          <img
                            src={`${process.env.REACT_APP_AWS_CERTIFICATES}${patient?.certificateUrl}`}
                            className="w-full sm:w-72 rounded-lg shadow-sm border border-gray-100 bg-white"
                            alt="Certificado"
                          />
                        )}
                      </div>
                    ) : (
                      <p className="italic text-gray-500">Sin archivo adjunto</p>
                    )
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </StyledWrapper.FormContainer>
  );
}
